// src/components/common/Notification.js
// GR33D-SIMPLIFIED-V2: [2025-02-26] - Système de notification amélioré

import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { useWeb3 } from '../../context/Web3Context';

// Variantes d'animation
const notificationVariants = {
    initial: { 
        opacity: 0, 
        y: -20,
        x: 100 
    },
    animate: { 
        opacity: 1, 
        y: 0,
        x: 0,
        transition: {
            type: "spring",
            damping: 15,
            stiffness: 100
        }
    },
    exit: { 
        opacity: 0, 
        x: 100,
        transition: {
            duration: 0.2
        }
    }
};

// Composant de notification individuelle
export const Notification = ({ 
    message, 
    type = 'info', 
    onClose, 
    txHash = null 
}) => {
    return (
        <motion.div 
            className={`notification ${type}`}
            variants={notificationVariants}
            initial="initial"
            animate="animate"
            exit="exit"
        >
            {message}
            {txHash && (
                <a 
                    href={`https://etherscan.io/tx/${txHash}`}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="tx-link"
                >
                    View on Etherscan
                </a>
            )}
            <button 
                className="notification-close"
                onClick={onClose}
            >
                ×
            </button>
        </motion.div>
    );
};

// Conteneur de notifications connecté au contexte
export const NotificationContainer = () => {
    const { notifications, removeNotification } = useWeb3();
    
    return (
        <div className="notification-container">
            <AnimatePresence>
                {notifications.map((notification) => (
                    <Notification
                        key={notification.id}
                        message={notification.message}
                        type={notification.type}
                        txHash={notification.txHash}
                        onClose={() => removeNotification(notification.id)}
                    />
                ))}
            </AnimatePresence>
        </div>
    );
};

export default NotificationContainer;
